import React from "react";
import { Home } from "./pages/Home";

export const App = () => {
  return (
    <div>
      <Home />
    </div>
  );
};
